module.exports = __webpack_public_path__ + "static/media/luminor.2167a519.png";